var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../button';
import { Styled } from './style';
var ConfirmModal = /** @class */ (function (_super) {
    __extends(ConfirmModal, _super);
    function ConfirmModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleConfirm = function () {
            if (_this.props.confirm) {
                _this.props.confirm();
            }
            // fallback, to be remove
            if (_this.props.onConfirm) {
                _this.props.onConfirm();
            }
        };
        _this.handleCancel = function () {
            if (_this.props.onCancel) {
                _this.props.onCancel();
            }
        };
        return _this;
    }
    ConfirmModal.prototype.render = function () {
        var _a = this.props, children = _a.children, cancelButton = _a.cancelButton, confirmButton = _a.confirmButton, isDanger = _a.isDanger, header = _a.header;
        return (React.createElement(React.Fragment, null,
            React.createElement(Styled, __assign({}, this.props),
                header &&
                    React.createElement("div", { className: "md-title", id: "confirm-title" },
                        React.createElement("h3", null, header)),
                React.createElement("div", { className: "confirm-content" }, children),
                header ? (React.createElement("div", { className: "md-footer", id: "confirm-footer" },
                    React.createElement("div", { className: "buttons" },
                        React.createElement(Button, { onClick: this.handleCancel, className: "btn-cancel" }, cancelButton ? (cancelButton) : (React.createElement(FormattedMessage, { id: "ui_component.common.label.cancel", defaultMessage: "Cancel" }))),
                        React.createElement(Button, { primary: isDanger ? false : true, danger: isDanger, autoFocus: isDanger ? false : true, onClick: this.handleConfirm, className: "ui button btn-confirm", tabIndex: "0" }, confirmButton
                            ? confirmButton
                            : React.createElement(FormattedMessage, { id: "ui_component.common.label.confirm", defaultMessage: "Confirm" }))))) : (React.createElement("div", { className: "buttons" },
                    !this.props.isAlert && !this.props.customButton &&
                        React.createElement(Button, { onClick: this.handleCancel, className: "btn-cancel" }, cancelButton ? (cancelButton) : (React.createElement(FormattedMessage, { id: "ui_component.common.label.cancel", defaultMessage: "Cancel" }))),
                    this.props.customButton ? (this.props.customButton) : (React.createElement(Button, { primary: isDanger ? false : true, danger: isDanger, autoFocus: isDanger ? false : true, onClick: this.handleConfirm, className: "ui button btn-confirm", tabIndex: "0" }, confirmButton
                        ? confirmButton
                        : React.createElement(FormattedMessage, { id: "ui_component.common.label.confirm", defaultMessage: "Confirm" }))))))));
    };
    return ConfirmModal;
}(React.Component));
export default ConfirmModal;
//# sourceMappingURL=index.js.map